/* eslint-disable max-lines */
/* eslint-disable xss/no-mixed-html */
/* eslint-disable max-statements */

(() => {
  let structure = '';

  const deliveryMethodText = $('.ph-orderhistory__deliverymethod').text(),
      deliveryPrefText = $('.ph-orderhistory__deliverypref').text(),
      singleShipText = $('.ph-orderhistory__singleship').text(),
      shipToText = $('.ph-orderhistory__shiptonumber').text(),
      multipleShipText = $('.ph-orderhistory__multipleship').text(),
      adminFeeText = $('.ph-orderhistory__adminfee').text(),
      contactNumber = $('.ph-orderhistory__contactnumber').text(),
      paymentMethod = $('.ph-orderhistory__paymentmethod').text(),
      orderPlacedby = $('.ph-orderhistory__orderplacedby').text(),
      deliveryInstruction = $('.ph-orderhistory__deliveryinstruction').text(),
      ponumberlabel = $('.ponumberlabel').text(),
      shippingAddText = $('.ph-orderhistory__shippingaddress').text(),
      billingAddText = $('.ph-orderhistory__billingaddress').text(),
      payeeAddText = $('.ph-orderhistory__payeeaddress').text(),
      taxText = $('.ph-orderhistory__tax').text(),
      totalPcmsText = $('.ph-orderhistory__total').text();

  const allAddresses = (add) => {
    structure = `${structure} <div>
          <ul class="ph-pl-0">
            <li> ${add.companyName} </li>`;

    if (add.companyName2 !== null) {
      structure = `${structure} <li> ${add.companyName2}</li>`;
    }

    structure = `${structure} <li> ${add.line1} </li>`;

    if (add.europeanAddressFormat === 'true') {
      structure = `${structure} <li> ${add.postalCode}  ${add.town} </li>`;
    } else {
      structure = `${structure} <li> ${add.town},`;

      if ($('.showRegion').html() === 'true' && add.region && add.region.isocodeShort) {
        structure = `${structure} ${add.region.isocodeShort}`;
      }

      structure = `${structure} ${add.postalCode}</li>`;
    }

    structure = `${structure}</ul>
        </div>`;
  };

  const personalDeliveryDetails = (personalInfo, paymentInfo) => {
    structure = `${structure}
                 <div class="ph-col-12 ph-p-0 ph-float-left">
                   <div class="ph-col-6 ph-float-left">
                     <p class="strong">${personalInfo}</p>
                   </div>
                   <div class="ph-col-6 ph-float-left">
                     <p>${paymentInfo}</p>
                   </div>
                 </div>`;
  };

  const paymentMethodValue = (data) => {
    let paymenttypeValue = '';

    if (data.paymentType && data.paymentType.code) {
      if (data.paymentType.code === 'ACCOUNT') {
        paymenttypeValue = $('.ph-paymenttypeAccount').text();
      } else if (data.paymentType.code === 'FINANCE') {
        paymenttypeValue = $('.ph-paymenttypeFinance').text();
      } else {
        paymenttypeValue = $('.ph-paymenttypeCard').text();
      }

      personalDeliveryDetails(paymentMethod, paymenttypeValue);
    }
  };

  const deliveryInformation = (data) => {
    if (data.deliveryPhone !== '' && data.deliveryPhone !== null) {
      personalDeliveryDetails(contactNumber, data.deliveryPhone);
    }

    paymentMethodValue(data);

    if (data.deliveryAttention !== '' && data.deliveryAttention !== null) {
      personalDeliveryDetails(deliveryInstruction, data.deliveryAttention);
    }

    structure = `${structure} ${ACC.newOrderHistory.spDeliveryInformation(data)}`;

    if (data.uid !== '' && data.uid !== null) {
      personalDeliveryDetails(orderPlacedby, data.b2bCustomerData.uid);
    }
  };

  const ponumber = (data) => {
    if (data.purchaseOrderNumber !== '') {
      structure = `${structure} <div class="ph-col-12 ph-p-0 ph-float-left">
      <div class="ph-col-6  ph-ponumber ph-float-left strong"><p class="ph-ponumber-label">${ponumberlabel}</p></div>
      <div class="ph-col-6  ph-ponumber ph-float-left"><p class="ph-ponumber-value ph-wordBreak">${data.purchaseOrderNumber}</p></div></div>`;
    }
  };

  const addressDetails = (address, addressDelivery) => {
    structure = `${structure}
                 <div class="ph-col-12 ph-float-left"> 
                   <span class="strong"> ${address}</span>
                   <p> ${addressDelivery}</p>
                 </div>`;
  };

  const addressType = (addType, dataAddType) => {
    structure = `${structure} 
                 <div class="ph-col-md-6 ph-col-sm-12 ph-float-left">
                   <span class="strong"> ${addType} </span>`;
    allAddresses(dataAddType);
    structure = `${structure} </div>`;
  };

  const hhsPage = (data) => {
    structure = `${structure} <div class="ph-orderhistory_panelcollapse ph-collapse">
    <div class="ph-mediadiv ph-float-right ph-col-lg-2 ph-col-md-2 ph-col-sm-3">
    <span class="ph-printicon-image ph-print-order"></span>
      </div>
      <div class="ph-orderhistory__panelbody ph-orderhistory_border ph-col-12 ph-float-left">
      <div class="ph-orderhistory__paymentdetails ph-orderhistory_border ph-orderhistory_fontstyle ph-col-12 ph-px-0 ph-float-left">`;

    ponumber(data);

    deliveryInformation(data);
    structure = `${structure} </div>
    <div class="ph-orderhistory_address ph-orderhistory_border ph-col-12 ph-px-0 ph-float-left">`;

    if (data.deliveryAddress !== null) {
      addressType(shippingAddText, data.deliveryAddress);
    }

    structure = `${structure} <div class="ph-col-md-6 ph-col-sm-12 ph-p-0 ph-float-right">`;

    if (data.deliveryMode !== null) {
      addressDetails(deliveryMethodText, data.deliveryMode.name);
    }

    if (data.isCompleteDelivery !== null) {
      structure = `${structure}
      <div class="ph-col-12 ph-float-left"> 
        <span class="strong"> ${deliveryPrefText}</span>`;

      if (data.isCompleteDelivery) {
        structure = `${structure} <p>${singleShipText}</p>`;
      } else {
        structure = `${structure} <p>${multipleShipText}</p>`;
      }

      structure = `${structure} </div>`;
    }

    if (data.deliveryAddress && data.deliveryAddress.customerNumber) {
      addressDetails(shipToText, data.deliveryAddress.customerNumber);
    }

    structure = `${structure}
                 </div></div>
      <div class="ph-col-12 ph-p-0 ph-float-left"></div>
      <div class="ph-lazyloaded-invoices"></div>`;
  };

  const deliveryDetails = (data) => {
    if (data.deliveryMode !== null && data.deliveryMode.name !== null) {
      addressDetails(deliveryMethodText, data.deliveryMode.name);
    }

    structure = `${structure}
                <div class="ph-col-12 ph-float-left"> 
                <span class="strong">${deliveryPrefText}</span>`;

    if (data.isCompleteDelivery !== null && data.isCompleteDelivery === true) {
      structure = `${structure} <p>${singleShipText}</p>`;
    } else {
      structure = `${structure} <p>${multipleShipText}</p>`;
    }

    structure = `${structure} </div>`;

    if ((data.deliveryAddress !== null && data.deliveryAddress !== '') &&
        (data.deliveryAddress.customerNumber !== null && data.deliveryAddress.customerNumber !== '')) {
      addressDetails(shipToText, data.deliveryAddress.customerNumber);
    }
  };

  const pcms = (data) => {
    structure = `${structure}
                 <div class="ph-orderhistory_panelcollapse ph-collapse">
                   <div class="ph-mediadiv ph-float-right ph-col-lg-2 ph-col-md-2 ph-col-sm-3">
                     <span class="ph-printicon-image ph-print-order"></span>
                   </div>
                   <div class="ph-orderhistory__panelbody ph-orderhistory_border ph-col-12 ph-float-left">
                   <div class="ph-orderhistory_details ph-orderhistory_border ph-mb-1 ph-col-12 ph-p-0 ph-float-left">`;

    ponumber(data);

    deliveryInformation(data);

    structure = `${structure} 
                </div>
                <div class="ph-orderhistory_address ph-orderhistory_border ph-col-12 ph-p-0 ph-float-left">
                <div class="ph-col-6 ph-p-0 ph-float-left">`;

    if ((data.status !== '') && (data.paymentAddress !== null && data.paymentType.code === 'ACCOUNT')) {
      addressType(billingAddText, data.paymentAddress);
    }

    if (data.deliveryAddress !== null) {
      addressType(shippingAddText, data.deliveryAddress);
    }

    if ((data.status !== '' && String(data.isSparePartOrder) !== 'true') &&
      (data.payerAddress !== null && data.paymentType.code === 'ACCOUNT')) {
      addressType(payeeAddText, data.payerAddress);
    }

    structure = `${structure} </div>
     <div class="ph-col-6 ph-p-0 ph-float-left">`;

    deliveryDetails(data);

    structure = `${structure} </div></div><div class="ph-lazyloaded-invoices hidden"></div>`;
  };

  const additionalCost = (data) => {
    const totalSavings = $('.ph-orderhistory__savings').text(),
        delivery = $('.ph-orderhistory__delivery').text(),
        adminFee = $('.ph-orderhistory__adminfee').text();

    if ($('.ph-showadditionalcost').html() === 'true') {
      structure = `${structure} <div class="ph-col-12 ph-float-left ph-orderhistory_totval">
    <span class="ph-float-left ph-savings"> ${totalSavings} </span>
    <span  class="ph-float-right">${data.totalPromotionDiscount.formattedValue}</span>
    </div>`;
    } else if (data.totalDiscounts.value > 0) {
      structure = `structure + '<div class="ph-col-12 ph-float-left ph-orderhistory_totval">\n' +
    <span class="ph-float-left ph-savings"> ${totalSavings} </span>
     <span class="ph-float-right"> ${data.totalDiscounts.formattedValue}</span>
    </div>`;
    }

    if ($('.ph-showadditionalcost').html() === 'true' && data.deliveryMode.deliveryCost !== '') {
      const showAdditionalCost = $('.ph-showadditionalcost').attr('priceData');

      structure = `${structure} <div class="ph-col-12 ph-float-left ph-orderhistory_totval">
              <span class="ph-float-left"> ${delivery} </span>`;

      if (data.deliveryMode.deliveryCost.value >= 0) {
        structure = `${structure} <span class="ph-float-right">${data.deliveryMode.deliveryCost.formattedValue}</span>`;
      } else {
        structure = ` ${structure} <span class="ph-float-right">${showAdditionalCost}</span>`;
      }

      structure = `${structure} </div>`;
    }

    if (data.adminFee !== '' && data.adminFee > 0) {
      structure = `${structure} <div class="ph-col-12 ph-float-left ph-orderhistory_totval">
  <span class="ph-float-left">${adminFee}</span>
  <span class="ph-float-right"> ${data.adminFee} </span>
  </div>`;
    }
  };

  const pcmshhss = (data) => {
    structure = `${structure} <div class="ph-orderhistory_total ph-orderhistory_border ph-mt-1 ph-col-12 ph-p-0 ph-float-left">`;

    additionalCost(data);

    if (data.net === true) {
      structure = `${structure} 
                   <div class="ph-col-12 ph-float-left ph-orderhistory_totval">
                     <span class="ph-float-left">  ${taxText} </span>
                     <span  class="ph-float-right">${data.totalTax.formattedValue} </span>
                   </div>
                   <div class="ph-col-12 ph-float-left ph-mb-1 ph-orderhistory_totval">
                     <span class="ph-float-left ph-total"> ${totalPcmsText} </span>
                     <span  class="ph-float-right ph-font-weight-bold ph-total">${data.totalPriceWithTax.formattedValue} </span>
                   </div>`;
    } else {
      structure = `${structure} 
                   <div class="ph-col-12 ph-float-left ph-mb-1 ph-orderhistory_totval">
                     <span class="ph-float-left ph-total">${totalPcmsText} </span>
                     <span  class="ph-float-right ph-font-weight-bold ph-total">${data.totalPrice.formattedValue}</span>
                   </div>`;
    }

    if (data.net === false) {
      structure = `${structure} <p>Your order includes tax</p>`;
    }

    if (data.adminFee !== '' && data.adminFee > 0) {
      structure = `${structure} <p> ${adminFeeText} </p>`;
    }
  };

  /**
   * @param {json} data - Contains sparePart data
   * @returns {void} - This doesn't return anything.
   * @example sparePart();
   */

  const sparePart = (data) => {
    let displayOrderId = data.code;

    if (data.sapOrderId && data.sapOrderId !== data.code) {
      displayOrderId = data.sapOrderId;

      if (document.querySelector('.ph-ishhs').textContent === 'true') {
        displayOrderId = `${displayOrderId} (${data.code})`;
      }
    } else if (String(data.isSparePartOrder) === 'true' && data.sapOrderId === null) {
      displayOrderId = document.querySelector('.ph-orderhistory__nullspsorderid').textContent;
    }

    structure = `${structure} <div data-orderid=${data.code} class= "accordion-toggle ph-orderhistory_title
                 ph-col-6 ph-col-md-4 ph-float-left" data-toggle="collapse"
                 data-parent="#accordion" aria-expanded="false" data-isSparePartOrder=${data.isSparePartOrder}>${displayOrderId}</div>`;

    if (data.purchaseOrderNumber !== '') {
      structure = `${structure} <div class="ph-col-6 ph-col-md-8 ph-ponumber ph-float-left ph-d-flex">
                                 <span class="ph-ponumber-label">${ponumberlabel}</span>
                                 <span title=${data.purchaseOrderNumber} class="ph-ponumber-value ph-text-truncate">${data.purchaseOrderNumber}</span>
                                </div> `;
    }

    if (data.user.uid !== '' && document.querySelector('.showAllSPSOrder').textContent === 'true') {
      const sporderby = document.querySelector('.sporderby').textContent;

      structure = `${structure} <div class="ph-col-6 ph-col-md-4 ph-sporderplacedby ph-float-left hidden">
                                  <div class="ph-float-left ph-text-nowrap">${sporderby}${data.user.uid}</div>
                                </div>`;
    }
  };

  /**
   * @param {json} data - Contains prices data
   * @returns {void} - This doesn't return anything.
   * @example prices();
   */

  const prices = (data) => {
    structure = `${structure} <div class="ph-col-12 ph-orderhistory_titleinfo ph-p-0 ph-float-left">
                               <span class="ph-col-4 ph-pr-0 ph-float-left ph-orderhistory_fontstyle">${data.stringDate}</span>
                               <span class="ph-col-3 ph-pr-1 ph-orderhistory_tolprice ph-orderhistory_fontstyle ph-float-left">`;

    if (data.net === true) {
      structure = `${structure} <span>${data.totalPriceWithTax.formattedValue}</span>`;
    } else {
      structure = `${structure} <span>${data.totalPrice.formattedValue}</span>`;
    }

    structure = `${structure} </span>
                              <span class="ph-col-4 ph-pr-0 ph-float-left ph-orderhistory-created">
                                <span class="ph-orderhistory-dot ph-float-left ph-${data.status.code}"></span>
                                <p class="ph-orderhistory__status ph-orderhistory_fontstyle ph-mb-0">${data.statusCode}</p>
                              </span></div></div>`;
  };

  /**
   * @param {json} data - Contains approverComments data
   * @returns {void} - This doesn't return anything.
   * @example approverComments();
   */

  const approverComments = (data) => {
    if (data.b2bPermissionResult.length > 0 && data.b2bPermissionResult[0].statusDisplay === 'Rejected') {
      structure = `${structure} <div class="ph-orderhistory_approver ph-orderhistory_border ph-mt-1 ph-col-12 ph-px-0 ph-float-left">
                                  <div class="ph-col-12 ph-p-0 ph-float-left">
                                    <div class="ph-col-md-6 ph-col-sm-12 ph-float-left">
                                      <p class="strong">Approver</p>
                                      <p>${data.b2bPermissionResult[0].approver}</p>
                                    </div>
                                    <div class="ph-col-md-6 ph-col-sm-12 ph-float-left ph-mt-3">
                                      <span class="ph-pr-0 ph-float-left ph-orderhistory-created">
                                        <span class="ph-orderhistory-dot ph-${data.b2bPermissionResult[0].status.code} ph-float-left"></span>
                                        <p class="ph-orderhistory__status ph-orderhistory_fontstyle 
                                         ph-mb-0">${data.b2bPermissionResult[0].statusDisplay}</p>
                                      </span>
                                    </div>
                                    <div class="ph-col-12 ph-float-left">
                                      <p class="strong">Comments</p>
                                      <div>${data.b2bPermissionResult[0].approverNotes}</div>
                                     </div>
                                    </div></div>`;
    }
  };

  /**
   * @param {json} data - Contains productDetails data
   * @returns {prodlistStruc} - This function returns prodlistStruc.
   * @example productDetails();
   */

  const productDetails = (data) => {
    let prodlistStruc = '';

    prodlistStruc = `${prodlistStruc} <ul class="ph-m-0">
      <li class="ph-orderhistory_productlist ph-float-left ph-p-0 ph-m-0 ph-col-12 ph-mt-1">`;

    prodlistStruc = `${prodlistStruc} ${ACC.newOrderHistory.setProductImage(data)}`;

    prodlistStruc = `${prodlistStruc} <div class="prod_info ph-float-left ph-pr-0 ph-orderhistory_prodinfo">
        <div class="ph-col-md-7 ph-float-left ph-col-sm-12 ph-p-0">
        <a class="ph-orderhistory_prodname ph-col-12 ph-float-left ph-p-0"`;

    prodlistStruc = `${prodlistStruc} ${ACC.orderHistory.productDetailsCondition(data)}`;

    prodlistStruc = `${prodlistStruc} </a>
      <div class="ph-orders__invoice__details ph-float-left ph-col-12 ph-p-0" id="productDetails_${data.entryNumber}"></div></div>
      <div class="ph-float-left ph-orderhistory_prodprice ph-orderhistory_fontstyle ph-orderhistory_productname ph-col-md-5 ph-col-sm-12 ph-p-0">
      <div class="ph-orderhistory_qty ph-col-6 ph-float-left ph-p-0">
      <span class="ph-orderhistory_qtytext" data-qtypurchased="${data.quantity}" >
        ${document.querySelector('.ph-orderhistory__qty').textContent} : </span>
      <span><span>${data.quantity}</span></span>`;

    if ($('.ph-displayuom').html() === 'true') {
      prodlistStruc = `${prodlistStruc} <span>${data.product.unitOfMeasure}</span>`;
    }

    prodlistStruc = `${prodlistStruc} </span>
      </div>
      <div class="ph-orderhistory_price ph-col-6 ph-float-left ph-p-0">
      <span>${data.totalPrice.formattedValue}</span>
      </div>
      </div>
      </div>
      <div class="ph-identifystatusestd-${String(data.deliveryStatus)} ph-col-12 ph-float-left ph-m-0 ph-p-0 ph-lazyloadestdate"
      id="lazyloadestdate${data.orderCode}_${data.entryNumber}"></div>`;

    if ((data.deliveryStatus === 'SHIPPED' || data.deliveryStatus === 'INVOICED') && data.shipmentDate) {
      prodlistStruc = `${prodlistStruc} ${ACC.orderHistory.shippedOnDetails(data.shipmentDate)}`;
    } else if ((data.entryNumber === data.deliveryItemsQuantity) && data.orderCode === data.confirmationNumber && data.estDelDate) {
      prodlistStruc = `${prodlistStruc} ${ACC.orderHistory.estDeliveryDetails(data.estDelDate)}`;
    }

    prodlistStruc = `${prodlistStruc} </li></ul>`;

    return prodlistStruc;
  };

  /**
   * @param {json} data - Contains orderHistoryDetailsPart data
   * @returns {productionHtml} - This function returns productionHtml.
   * @example orderHistoryDetailsPart();
   */

  const orderHistoryDetailsPart = (data, trackingHtml, commonEnrties) => {
    let productionHtml = '';

    productionHtml = `${productionHtml} <div class="ph-orderhistory_tobeshippedproduct ph-col-12 ph-p-0 ph-mb-1 ph-float-left">`;

    if (document.querySelector('.ph-ishhs').textContent === 'true') {
      if (trackingHtml !== '') {
        productionHtml = `${productionHtml} ${trackingHtml}`;
      }

      productionHtml = `${productionHtml} <div data-productcode="${data.product.code}"
                  class="ph-col-12 ph-float-left ph-p-0 ph-lazyload-deliveryitemlist" 
                  id = "lazyloadpackinglist${data.orderCode}_${data.entryNumber}"></div>`;
    } else if (data.deliveryStatus === 'SHIPPED' || data.deliveryStatus === 'INVOICED') {
      if (commonEnrties.showShipped) {
        productionHtml = `${productionHtml} <span class="ph-orderhistory_fontstyle ph-orderHistory__shippedLabelClass">
                          ${commonEnrties.shippedlabelmsg}:</span>`;
        commonEnrties.showShipped = false;
      }

      productionHtml = `${productionHtml} <span class="hidden shipmentcarriername">`;

      if (String(data.carrierName) !== 'null' && String(data.carrierName) !== '') {
        productionHtml = `${productionHtml} ${data.carrierName}`;
      }

      productionHtml = `${productionHtml} </span>`;
      productionHtml = `${productionHtml} <span class=" ph-lazyload-tracking" id="lazyloadTracking${data.orderCode}_${data.entryNumber}"></span>`;
    }

    productionHtml = `${productionHtml} ${productDetails(data)}`;

    productionHtml = `${productionHtml} </div>`;

    return productionHtml;
  };

  /**
   * @param {json} data - Contains productIterationPart data
   * @returns {void} - This function doesnot return anything.
   * @example productIterationPart();
   */

  const productIterationPart = (orderDetailsMapDataEntries, isSpOrder) => {
    let trackingHtml = '',
        currentTrackUrl = '',
        deliveryStatusValue = '';

    const shippedlabelmsg = $('.shippedlabelmsg').text().trim(),
        shipmenttrackmsg = $('.shipmenttrackmsg').text().trim(),
        groupOrderProducts = {},
        commonEnrties = {
          showShipped: true,
          shippedlabelmsg
        };

    for (const entriesorderdetails in orderDetailsMapDataEntries) {
      if (orderDetailsMapDataEntries !== '') {
        const productEntryData = orderDetailsMapDataEntries[entriesorderdetails];

        productEntryData.isSparePartOrder = isSpOrder;

        if (productEntryData.orderEntryTrackingURLDetails.length > 0 &&
            String(productEntryData.orderEntryTrackingURLDetails[0].trackingURL) !== 'undefined' &&
            String(productEntryData.orderEntryTrackingURLDetails[0].trackingURL) !== '') {
          currentTrackUrl = productEntryData.orderEntryTrackingURLDetails[0].trackingURL;

          if (currentTrackUrl !== '') {
            trackingHtml = `<span class="ph-orderhistory_fontstyle ph-orderHistory__shippedLabelClass ph-sparepart_ack_reorder ph-py-1
                              ph-col-12 ph-float-left ph-px-0">
                               ${shippedlabelmsg}
                               (<a href="${currentTrackUrl}" target="_blank" class="confirmation-link">${shipmenttrackmsg}</a>) 
                            &nbsp;</span> `;
          }
        }

        deliveryStatusValue = ACC.orderHistory.getDeliveryStatusValue(productEntryData);

        if (!groupOrderProducts[deliveryStatusValue]) {
          groupOrderProducts[deliveryStatusValue] = '';
        }

        groupOrderProducts[deliveryStatusValue] = `${groupOrderProducts[deliveryStatusValue]} 
                                                   ${orderHistoryDetailsPart(productEntryData, trackingHtml, commonEnrties)}`;
      }
    }


    structure = `${structure} ${ACC.orderHistory.renderGroupedOrderProducts(groupOrderProducts)}`;
  };

  /**
   * @param {json} data - Contains orders data
   * @param {string} orderkey - contains order key
   * @returns {void} - This doesn't return anything.
   * @example orderHeader();
   */
  const orderHeader = (data, orderkey) => {
    if (data.currentUser === data.b2bCustomerData.uid) {
      structure = `${structure} <div class="ph-col-12 ph-orderhistory__container ph-printorder-list ph-mb-1 ph-float-left ph-p-0">
                   <div id="orderHistoryPanelCode__${orderkey}" class="ph-orderhistory_panel ph-orderhistory_paneldefault">
                   <div class="ph-orderhistory_panelheading">
                   <div class="ph-orderhistory_paneltitle ph-icon-arrow-down ph-orderhistory_border ph-col-12 ph-float-left">`;
    } else {
      structure = `${structure} <div class="ph-col-12 ph-orderhistory__container ph-printorder-list ph-allOrders hidden ph-mb-1 ph-float-left ph-p-0">
                  <div class="ph-orderhistory_panel ph-orderhistory_paneldefault">
                  <div class="ph-orderhistory_panelheading">
                  <div class="ph-orderhistory_paneltitle ph-icon-arrow-down ph-orderhistory_border ph-col-12 ph-float-left">`;
    }
  };

  const titlePart = (data) => {
    const [wrapper] = document.querySelectorAll('.ph-myOrders-data'),
        productionInOrder = $('.ph-orderhistory__prodinorder').text();
    const orderDetailsMapData = data.orderDetailsMap;

    for (const orderdetails in orderDetailsMapData) {
      if (orderDetailsMapData !== '') {
        structure = '';
        orderHeader(orderDetailsMapData[orderdetails], orderdetails);

        sparePart(orderDetailsMapData[orderdetails]);

        prices(orderDetailsMapData[orderdetails]);

        if (document.querySelector('.ph-ishhs').textContent === 'true') {
          hhsPage(orderDetailsMapData[orderdetails]);
        } else {
          pcms(orderDetailsMapData[orderdetails]);
        }

        approverComments(orderDetailsMapData[orderdetails]);

        const orderDetailsMapDataEntries = orderDetailsMapData[orderdetails].entries,
            returnOrder = ACC.orderHistory.renderReturnOrderBtn(orderDetailsMapData[orderdetails]);

        const isThirtyDayMaskOrder = ACC.orderHistory.isThirtyDayMaskOrder(orderDetailsMapData[orderdetails]),
            reorderActionUrl = document.querySelector('.ph-reorderurl').textContent,
            reorderText = document.querySelector('.ph-orderhistory__reorder').textContent;

        pcmshhss(orderDetailsMapData[orderdetails]);
        structure = `${structure}
                     </div>
                     <div class="ph-orderhistory_products ph-pt-1 ph-col-12 ph-float-left" 
                       data-orderidnumber ="${orderdetails}">
                     <h4 class="ph-col-12 ph-p-0 ph-mb-1"> ${productionInOrder} (${orderDetailsMapData[orderdetails].totalItems})</h4>`;

        productIterationPart(orderDetailsMapDataEntries, orderDetailsMapData[orderdetails].isSparePartOrder);

        structure = `${structure} </div></div>
          <div class="ph-orderhistory_buttons ph-orderhistory_border ${isThirtyDayMaskOrder} ph-col-12 ph-float-left ph-pl-1">
          <form action=${reorderActionUrl} id="reorderForm" modelAttribute="reorderForm" method="POST">
          <input type="hidden" name="orderCode" path="orderCode" value=${orderDetailsMapData[orderdetails].code} />
          <button type="button" class="ph-orderhistory_reorder ph-sparepart_ack_reorder re-order ph-mt-0 ph-col-3 ph-float-left"
            id="reorderButton">
            ${reorderText}
          </button>`;

        structure = `${structure} ${ACC.newOrderHistory.createSmaxLink(data, returnOrder)}`;

        wrapper.insertAdjacentHTML('beforeend', structure);

        if ($('.ph-ishhs__unused').html() === 'true') {
          $('.ph-orderHistory__savedProductEntryData').data('key', orderDetailsMapData);

          if (orderDetailsMapData[orderdetails].isInvoiceDetailsPresent) {
            $(`#orderHistoryPanelCode__${orderdetails}`).find('.ph-orderhistory_paneltitle').addClass('lazyloaded');
            ACC.orderHistory.processLazyLoad(orderDetailsMapData,
              $(`#orderHistoryPanelCode__${orderdetails}`), orderdetails);
          }
        }

        $('.ph-myOrders').trigger('change');
      }
    }
  };

  /**
   * @description Loads content.
   * @returns {void} - This returns nothing.
   * @param {json} container - Container for intersection.
   * @param {json} observer - Observer for intersection.
   * @example loadContentSmartly();
   */
  const loadContentSmartly = (container, observer) => {
    const lengthCheck = document.querySelector('.ph-myOrders-data').childElementCount / document.querySelector('.ph-ordersshown').textContent,
        numberOfPages = parseInt(document.querySelector('.ph-ordersshown').getAttribute('data-pagenumber'), 10),
        pageLength = Math.ceil(lengthCheck),
        dataInitiated = 'data-initiated',
        getOrderHistoryUrl = 'ph-getOrderHistoryUrl',
        initiated = parseInt(document.querySelector(`.${getOrderHistoryUrl}`).getAttribute('data-initiated'), 10);

    if ((initiated < pageLength && pageLength < parseInt(document.querySelector(`.${getOrderHistoryUrl}`)
      .getAttribute('data-number-of-pages'), 10)) && (pageLength <= numberOfPages)) {
      document.querySelector(`.${getOrderHistoryUrl}`).setAttribute(dataInitiated, pageLength);

      if ((window.location.search.indexOf('orderCode') > 0) === false) {
        $.ajax({
          url: `${ACC.config.contextPath}${ACC.ordersLoader.ordersJsonUrl}?sort=${ACC.ordersLoader.currentSortingValue}&page=${pageLength}
          &filter=${ACC.ordersLoader.currentFilterValue}`.replace(/ /g, ''),
          dataType: 'json',
          async: false,
          success(data) {
            $('.ph-getOrderHistoryUrl').attr('data-loaded', pageLength);
            titlePart(data);
          }
        });
      }
    } else {
      document.querySelector('.ph-load').style.visibility = 'hidden';
    }

    observer.unobserve(container);
  };

  /**
   * @returns {void} - This returns nothing.
   * @example setObserver();
   */
  const setObserver = () => {
    const container = document.querySelector('.ph-intersection-observer'),
        activeOrderCheckAttribute = $('.ph-activeOderCheck').attr('data-active'),
        activeApprovalOrderCheckAttribute = $('.ph-activeApprovalCheck').attr('data-active'),
        freeTextSearchResult = $('.ph-freetextsearch__data').find('.ph-orderhistory_panelheading').length;

    /**
     * @returns {void} - This returns nothing.
     * @example intersection()
     */
    const intersection = () => {
      const observer = new IntersectionObserver((entries) => {
        entries.map((entry) => {
          const {isIntersecting} = entry;

          if ((isIntersecting && (activeOrderCheckAttribute === 'true' && freeTextSearchResult === 0)) ||
              (activeOrderCheckAttribute === 'false' && activeApprovalOrderCheckAttribute === 'false')) {
            loadContentSmartly(container, observer);
            observer.observe(container);
          }

          /* eslint-disable array-func/no-unnecessary-this-arg */
          return true;
        }, {
          /* eslint-enable array-func/no-unnecessary-this-arg */
          root: null,
          rootMargin: '0px',
          threshold: 0
        });
      });

      observer.observe(container);
    };

    if ('IntersectionObserver' in window) {
      intersection();
    } else {
      fetch(`${ACC.config.commonResourcePath}/philipsUI/src/js/vendor/intersection-observer.min.js`, () => {
        intersection();
      });
    }
  };

  $(document).ready(() => {
    const sortingSelectBox = () => {
      let newloader = '';

      newloader = '<div class="ph-loading-wrapper"><div class="ph-loadingtext">Loading...</div><div class="ph-smart-loader"></div></div>';

      if ($('.ph-myOrders-data').find('.ph-ordersfilter-loader').length === 0) {
        $('.ph-myOrders-data').prepend(`<div class="ph-ordersfilter-loader ph-p-0 ph-m-0 ph-col-12">${newloader}</div>`);
      }

      $.ajax({
        url: ACC.ordersLoader.getOrdersAjaxUrl(),
        dataType: 'json',
        async: true,
        success: (data) => {
          $('.ph-myOrders-data').html('');
          $('.ph-getOrderHistoryUrl').attr('data-initiated', 0);
          titlePart(data);
        },
        error: () => {
          $('.ph-myOrders-data').find('.ph-ordersfilter-loader').remove();
        }
      });
    };

    if ($('.ph-page-orders').length > 0) {
      if ($('.ph-ishhs').html() === 'true' && $('.ph-myApprovalOrders').is(':checked') === false &&
      (window.location.search.indexOf('orderCode') > 0) === false) {
        sortingSelectBox();
      }

      if ($('.template-pages-AccountPageTemplate .ph-myOrders-data .ph-orderhistory_paneltitle').length > 0) {
        const noSearchResultHidden = $('.ph-page-orders').find('.ph-freetextsearch__resultwrapper').hasClass('ph-d-none');

        if (noSearchResultHidden) {
          setObserver();
        }
      }

      const phActiveClass = 'ph-active',
          sortcodeAttribute = 'sortcode';

      $(document).on('click', '.ph-sorting__item', function() {
        if (!$('.ph-myApprovalOrders').is(':checked')) {
          $(document).find('.ph-sorting__item').removeClass(phActiveClass);
          $(this).addClass(phActiveClass);
          ACC.ordersLoader.hideSearchResult();
          ACC.ordersLoader.onSortingChanged($(this).attr(sortcodeAttribute));
          $('#ordersSortingSelect').attr(sortcodeAttribute, $(this).attr(sortcodeAttribute)).html($(this).html());
          ACC.ordersLoader.updatePageUrl();
          sortingSelectBox();
        }
      });
      window.addEventListener('popstate', (event) => {
        if (!$('.ph-myApprovalOrders').is(':checked')) {
          ACC.ordersLoader.onSortingChanged(event.state.sort);
          $(document).find('.ph-sorting__item').removeClass(phActiveClass);
          $(`#sortingItem_${event.state.sort}`).addClass(phActiveClass);
          $('#ordersSortingSelect').attr(sortcodeAttribute, event.state.sort).html($(`#sortingItem_${event.state.sort}`).html());
          sortingSelectBox();
        }
      });
    }
  });
})();
/* eslint-enable xss/no-mixed-html */
/* eslint-enable max-statements */
/* eslint-enable max-lines */
